import { useEffect } from 'react';
import PropTypes from 'prop-types';
import useLabels from 'infrastructure/js/hooks/useLabels';
import { SettingsMenuItemsIds } from '../../../../../enums/navigationMenuItemsIds.js';
import Header, { headerItemsLabels } from '../../../../Common/Header/header.js';
import { PL_DialogWrapper } from 'infrastructure/js/components/Dialog/dialog';
import TruckSensorsViewGrid from './TrucksSensorsViewGrid/trucksSensorsViewGrid.js';
import CreateTrucksSensorConfigDialog from './CreateTrucksSensorConfigDialog/createTrucksSensorConfigDialog.js';

import './trucksSensorsView.scss';

export default function TrucksSensorsView({ actions, sHasRows, sSelectedRowsData, sCreateTrucksSensorConfigDialog }) {
  const labels = useLabels('mat.administration.settings.trucksSensors.view.');

  useEffect(() => {
    actions.settingsPageActions.onSelectedMenuItemChanged(SettingsMenuItemsIds.NAV_ELEMENT_TRUCKS_SENSORS);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const headerItems = {
    title: labels.get('title'),
    buttons: [
      {
        id: 'clearFilters',
        label: '',
        icon: 'pl pl-filter-clear',
        action: actions.clearFilters,
        tooltip: headerItemsLabels.CLEAR_FILTERS,
      },
      {
        id: 'create',
        label: headerItemsLabels.CREATE,
        icon: 'pl pl-icon-add',
        action: actions.header.onCreateTrucksSensorConfigClick,
      },
      {
        id: 'edit',
        label: headerItemsLabels.EDIT,
        icon: 'pl pl-edit-icon',
        disabled: !(sHasRows && sSelectedRowsData.size === 1),
        action: actions.header.onEditTrucksSensorConfigClick,
        actionData: sSelectedRowsData.get(0),
      },
    ],
    kebab: {
      disabled: !sHasRows,
      menuItems: [
        {
          id: 'setAsDefault',
          label: headerItemsLabels.SET_AS_DEFAULT,
          action: actions.header.onSetTrucksSensorConfigAsDefaultClick,
          disabled: !sSelectedRowsData || sSelectedRowsData.size !== 1 || sSelectedRowsData.get(0).defaultProvider,
          actionData: sSelectedRowsData.get(0),
        },
        {
          id: 'remove',
          label: headerItemsLabels.REMOVE,
          action: actions.header.onDeleteTrucksSensorConfigsClick,
          disabled: sHasRows && (!sSelectedRowsData || sSelectedRowsData.size === 0),
          actionData: sSelectedRowsData.toJS().map((item) => item.id),
        },
      ],
    },
  };

  return (
    <div className="preferences-page">
      <Header {...headerItems} />
      <TruckSensorsViewGrid actions={actions.trucksSensorsViewGridActions} />
      <PL_DialogWrapper
        dialogComponent={CreateTrucksSensorConfigDialog}
        show={sCreateTrucksSensorConfigDialog.get('show')}
        actions={actions.createTrucksSensorConfigDialogActions}
        sData={sCreateTrucksSensorConfigDialog}
        reloadParentComponent={actions.reload}
      />
    </div>
  );
}

TrucksSensorsView.propTypes = {
  actions: PropTypes.object.isRequired,
  sHasRows: PropTypes.bool,
  sSelectedRowsData: PropTypes.object,
};
